<template>
  <div class="drop-menu-overlay" v-if="show" v-scroll-lock="show" v-on:click="hideMenu">
    <div class="drop-menu-inner md-scrollbar" v-on:click.stop="" :style="`height:${dropMenuConfig.height}`">
      <div v-html="dropMenuConfig.content" v-if="dropMenuConfig.type=='html'">
      </div>
      <iframe v-if="dropMenuConfig.type=='iframe'" :src="iframeUrl(dropMenuConfig.url)" scrolling="no" width="100%" id="loginiframe" name="loginiframe" :style="`height:${dropMenuConfig.height};border:none;`"></iframe>
      <div v-if="dropMenuConfig && dropMenuConfig.type == 'account-menu' && dropMenuConfig.account" class="account-menu">
        <div class="account-quick-links">
          <ul>
            <li><a href="/account/">{{$t('orders')}}</a></li>
            <li v-if="!dropMenuConfig.account.staff && dropMenuConfig.account.membershipEnable"><a href="/account/membership">{{$t('membership-program')}}</a></li>
            <li><a href="/account/profile">{{$t('account-profile')}}</a></li>
            <li><a href="/account/contactus">{{$t('contact-us')}}</a></li>
            <li><a href="/account/Signout">{{$t('sign-out')}}</a></li>
          </ul>
        </div>
        <div class="summary md-layout">
          <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-large-size-80 md-xlarge-size-70 page-container">
            <div class="md-layout">
              <div class="md-layout-item md-size-10" style="text-align: center;padding-top: 46px">
                  <img :src="dropMenuConfig.account.icon && dropMenuConfig.account.icon.length > 0 ? dropMenuConfig.account.icon : '/content2/images/account.jpg'" class="user-avatar">
              </div>
              <div class="md-layout-item md-size-50">
                  <h2 style="line-height: 1.1; font-size: 36px; color: #000; margin-top:0;">{{ "Welcome {0}".replace('{0}', dropMenuConfig.account.firstName) }}</h2>
                  <p class="news" v-html="news" v-for="(news, index) in dropMenuConfig.account.news" v-bind:key="index"></p>
              </div>
              <div class="md-layout-item md-size-10"></div>
              <div class="md-layout-item md-size-30">
                <div class="orders">
                  <p class="title">{{$t('recent-orders')}}</p>
                  <ul>
                    <li v-for="order in dropMenuConfig.account.orders" v-bind:key="order[0]">
                      <a :href="`/account/order/${order[0]}`">{{order[0]}}</a>: {{order[1]}}
                    </li>
                  </ul>
                  <p><a href="/account" class="view-all raa">View All Orders</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="md-layout md-alignment-center-center loading" v-if="loading&&dropMenuConfig.type=='iframe'">
        <md-progress-spinner class="md-accent" md-mode="indeterminate" :md-diameter="60"></md-progress-spinner>
      </div>
    </div>
    <div class="cross-btn">
      <md-button class="md-icon-button" v-on:click="hideMenu">
        <md-icon :md-src="`${imageServer}/new-rma/icon/close.svg`"></md-icon>
      </md-button>
    </div>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import * as types from '../store/mutation-types'
  import Auth from '../mixins/auth'
  import { apiServer,imageServer, publicPath } from '../config'
  export default {
    name: 'DropMenu',
    data: () => ({
      loading: false,
      imageServer: imageServer
    }),
    computed: {
      ...mapState({
        show: 'dropMenuVisible',
        dropMenuConfig: 'dropMenu',
        store: 'store'
      })
    },
    methods: {
      ...mapMutations({
        showMenu: types.SHOW_DROP_MENU,
        hideMenu: types.HIDE_DROP_MENU,
        changeMenu: types.CHANGE_DROP_MENU
      }),
      logInByEStore() {
        this.$http.get(`${publicPath}/js/store/json.aspx`).then(({data})=>{
          if (data && data.token && data.token.length > 0) Auth.updateMemberToken(data.token)
          window.console.log(data)
          this.$http.post(`${apiServer}/api/your-details/login-by-estore?store=` + this.store,
          { },
          { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).then(({ data }) => {
            if (data && data.email && data.email.length > 0 && data.token && data.token.length > 0) Auth.updateToken(data.token)
            window.console.log('r1')
            location.reload()
          }).catch(() => {
            window.console.log('r2')
            location.reload()
          })
        }).catch(()=>{
          window.console.log('r3')
          location.reload()
        })

      },
      iframeUrl(url) {
        return url
      }
    },
    created() {
      this.loading = true
    },
    mounted() {
      this.$scrollTo('#app')
      this.loading = true
      window.addEventListener('message', (e) => {
        if (typeof e.data === 'string' && e.data != '' && e.data.indexOf('{') == 0) {
          var result = JSON.parse(e.data)
          //window.console.log(result)
          if (result) {
            switch (result.action) {
              case 'update':
                var config = { ...this.dropMenuConfig }
                config.height = result.height + 'px'
                this.changeMenu(config)
                this.loading = false
                break
              case 'loginsuccess':
                this.logInByEStore()
                break
              case 'close':
                this.hideMenu()
                break
            }
          }
        }
      })
    }
  }
</script>

<style lang="scss" scoped>
  .drop-menu-overlay {
    position:absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    background: rgba(0,0,0,.5);
    min-height: 300px;
    height: 100%;
transition: .3s 0s ease-in-out transform, 0s .4s opacity;
transform: translateY(0);

    .drop-menu-inner
    {
      opacity: 1;
      min-height: 300px;
      background-color: #e6e6e6;
      transition: transform .3s ease-in-out,opacity;
      transform: translateY(0);
      box-shadow: 0 100px 100px rgba(0,0,0,.3);
      position: absolute;
      z-index: 10;
      top: 0;
      left: 0;
      width: 100%;
      max-height: 80vh;
      overflow-y: scroll;
      border-top: 1px solid #ccc;
      position:relative;
    }
  }

  .loading {
    position:absolute;
    z-index: 100;
    top:0;
    left:0;
    height: 100%;
    width: 100%;
  }

  .cross-btn {
    position:absolute;
    top: 10px;
    right:20px;
    z-index: 20
  }


  .account-quick-links {
    margin-bottom: 20px;
    text-align: center;
    background: #e8e8e8;
    padding-right: 40px;
    line-height: 58px;
    height: 58px;
  }

  .account-quick-links ul {
    margin: 0;
    padding: 0;
  }

  .account-quick-links li {
    margin: 0 20px;
    display: inline-block;
  }

    .account-quick-links li a {
      padding: 0;
      color: #777 !important;
      display: inline-block;
      border-bottom: 3px solid transparent;
      line-height: 52px;
      text-decoration: none !important;
      font-size: 16px;
    }

      .account-quick-links li.active a,
      .account-quick-links li a:hover {
        border-bottom-color: #008ad9;
      }

  .account-menu .summary {
    margin: 40px auto;
    position: relative;
    width: 80%;
  }

  .account-menu .user-avatar {
    border-radius: 50%;
    max-width: 100%;
    margin: 10px auto;
    display: block;
  }
  .account-menu .orders .title {
    font-size: 16px;
    color: #808080;
    font-weight: 100;
    text-transform: uppercase;
  }
 .account-menu .summary a {
    color: #008ad9 !important;
    text-decoration: none !important;
    border-bottom: 1px solid transparent;
    -webkit-transition: .3s;
    -o-transition: .3s;
    transition: .3s;
  }

  .account-menu .summary a:hover {
    border-bottom: 1px solid #008ad9;
  }

  .account-menu .summary ul {
    list-style: none;
    padding-left: 0;
    color: #000;
    font-weight: normal;
  }

  #product-menu h2 {
    font-weight: 600;
  }
  #product-menu h2 > a, #product-menu h2 > a:hover {
    border: none;
    text-decoration: none;
    color: #808080;
  }
  .menu-wrapper h2 > a {
    text-decoration: none;
    color: #333 !important;
  }
</style>